import { Icon } from "#components";
import { VIcon } from "vuetify/components";

export default defineComponent({
  name: "AppIcon",
  props: {
    name: { type: String, required: true },
    color: { type: String },
    size: { type: [String, Number] },
  },
  render() {
    if (this.name?.includes(":")) {
      // this is an iconify icon

      const style =
        "--v-icon-size-multiplier: 1;" +
        (isNumeric(this.size) ? `font-size:${convertToUnit(this.size)}` : "");
      const cls = !isNumeric(this.size) ? `v-icon--size-${this.size}` : "";

      return (
        <span class={"flex-center " + cls} style={style}>
          <Icon name={this.name} />
        </span>
      );
    }

    // this is local vuetify icon
    return (
      <span class="flex-center">
        <VIcon color={this.color} size={this.size}>
          {this.name}
        </VIcon>
      </span>
    );
  },
});
